export const NAVIGATION_BLOCK_NAME = 'Navigation';
export const HEADER_BLOCK_NAME = 'Header';
export const UTILITY_BAR_BLOCK_NAME = 'UtilityBar';
